import group from './_group.js';

// Indexes the object's values by a criterion, similar to `_.groupBy`, but for
// when you know that your index values will be unique.
export default group(function(result, value, key) {
  result[key] = value;
});



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/indexBy.js
// module id = 1891
// module chunks = 1